'use strict';
/* eslint-disable react/jsx-handler-names */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _reactDom = require('react-dom');

var _visibility = require('conversations-lib/visibility');

var visibility = _interopRequireWildcard(_visibility);

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _WindowActions = require('conversations-core/actions/WindowActions');

var _Widget = require('conversations-core/components/widget/Widget');

var _Widget2 = _interopRequireDefault(_Widget);

var _Launcher = require('conversations-core/components/widget/Launcher');

var _Launcher2 = _interopRequireDefault(_Launcher);

var _InitialMessageBubble = require('conversations-core/components/widget/InitialMessageBubble');

var _InitialMessageBubble2 = _interopRequireDefault(_InitialMessageBubble);

var _FadeTransition = require('conversations-core/components/transition/FadeTransition');

var _FadeTransition2 = _interopRequireDefault(_FadeTransition);

var _FadeSlideTransition = require('conversations-core/components/transition/FadeSlideTransition');

var _FadeSlideTransition2 = _interopRequireDefault(_FadeSlideTransition);

var _Defaults = require('conversations-schema/constants/Defaults');

var _strings = require('conversations-core/constants/strings');

var _ConversationFactory = require('conversations-core/factories/ConversationFactory');

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizes = (0, _reactUtils.keyMirror)({
  small: null,
  'extra-small': null,
  default: null
});

var INITIAL_MESSAGE_TIMEOUT = 30000;

exports.default = _react2.default.createClass({
  displayName: 'WidgetManager',

  propTypes: {
    style: _react.PropTypes.object,
    widgetData: _react.PropTypes.instanceOf(_WidgetData2.default),
    size: _react.PropTypes.oneOf(Object.keys(sizes)),
    chatHistoryFetchStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)),
    currentChannel: _react.PropTypes.string,
    currentConversation: _react.PropTypes.instanceOf(_Conversation2.default),
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    sendOfflineMessage: _react.PropTypes.func,
    sendVisitorEmailAddress: _react.PropTypes.func,
    clickedMeetingsLink: _react.PropTypes.func,
    clickedForUserDescription: _react.PropTypes.func,
    fetchNextHistory: _react.PropTypes.func,
    fetchInitialHistory: _react.PropTypes.func,
    mobile: _react.PropTypes.bool,
    preview: _react.PropTypes.bool,
    open: _react.PropTypes.bool,
    chatInputChanged: _react.PropTypes.func,
    showTypingIndicator: _react.PropTypes.bool,
    displayResponderOnline: _react.PropTypes.bool.isRequired,
    isOnlineMode: _react.PropTypes.bool.isRequired,
    hideWelcomeMessage: _react.PropTypes.bool,
    liveChatLink: _react.PropTypes.string,
    onLinkClick: _react.PropTypes.func.isRequired,
    clearUnseenCount: _react.PropTypes.func,
    showEmailCapture: _react.PropTypes.bool.isRequired,
    emailCaptureMessage: _react.PropTypes.string,
    emailCaptureMessageIndex: _react.PropTypes.number,
    visiblyOffline: _react.PropTypes.bool.isRequired,
    onUpdateSize: _react.PropTypes.func,
    onUpdateOpened: _react.PropTypes.func,
    onHideWelcomeMessage: _react.PropTypes.func,
    hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
    isAgentReady: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: sizes.default,
      open: false,
      preview: false,
      hideWelcomeMessage: false,
      isHubSpotPortal: false,
      onUpdateSize: function onUpdateSize() {},
      onUpdateOpened: function onUpdateOpened() {},
      onHideWelcomeMessage: function onHideWelcomeMessage() {}
    };
  },
  getInitialState: function getInitialState() {
    var hideWelcomeMessage = this.props.hideWelcomeMessage;


    return {
      showInitialMessage: !hideWelcomeMessage,
      initialMessageTimedOut: false,
      hasLoadedHistory: false
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    if (!this.props.preview) {
      setTimeout(function () {
        _this.setState({
          showInitialMessage: false
        });
      }, INITIAL_MESSAGE_TIMEOUT);
    }
    visibility.removeVisibilityChangeListener(this.handleVisibilityChange);
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        onUpdateOpened = _props.onUpdateOpened,
        onUpdateSize = _props.onUpdateSize,
        open = _props.open;


    if (this.shouldRenderWidget()) {
      onUpdateSize(this.getIframeDimensions());

      // TODO: Close the widget before reloading
      onUpdateOpened(open);
    }

    visibility.addVisibilityChangeListener(this.handleVisibilityChange);
    this.fetchChatHistory();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var open = nextProps.open,
        preview = nextProps.preview;
    var currentlyOpen = this.props.open;


    if (open !== currentlyOpen) {
      this.setState({
        showInitialMessage: !open && preview
      });
    }

    // history is received once before initial widget render
    // then fetched again once the widget has connected to pubnub
    if (nextProps.chatHistoryFetchStatus === _RequestStatusTypes2.default.SUCCEEDED) {
      this.setState({
        hasLoadedHistory: true
      });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var onUpdateSize = this.props.onUpdateSize;


    if (this.shouldRenderWidget()) {
      onUpdateSize(this.getIframeDimensions());
    }
  },
  handleVisibilityChange: function handleVisibilityChange(_ref) {
    var isVisible = _ref.isVisible;
    var open = this.props.open;


    if (open) {
      (0, _WindowActions.setWindowVisible)(isVisible);
    }
  },
  getParentUrl: function getParentUrl() {
    return document.referrer;
  },
  getIframeDimensions: function getIframeDimensions() {
    var _props2 = this.props,
        open = _props2.open,
        initialMessage = _props2.widgetData.initialMessage;
    var showInitialMessage = this.state.showInitialMessage;

    var activeContentRef = void 0;

    switch (true) {
      case open:
        activeContentRef = this.widgetRef;
        break;
      case !open && initialMessage !== null && showInitialMessage:
        activeContentRef = this.initialMessageRef;
        break;
      default:
        activeContentRef = null;
        break;
    }

    var launcher = this.launcherRef.getBoundingClientRect();
    var activeContent = activeContentRef ? activeContentRef.getBoundingClientRect() : null;

    return {
      width: (activeContent ? activeContent.width : launcher.width) + 16,
      height: launcher.height + (activeContent ? activeContent.height : 0) + 16
    };
  },
  getCurrentChannel: function getCurrentChannel() {
    var _props3 = this.props,
        currentChannel = _props3.currentChannel,
        preview = _props3.preview;


    if (preview) {
      return _Defaults.MOCK_CURRENT_CHANNEL;
    }

    return currentChannel;
  },
  getCurrentConversation: function getCurrentConversation() {
    var _props4 = this.props,
        initialMessage = _props4.widgetData.message.initialMessage,
        preview = _props4.preview,
        currentConversation = _props4.currentConversation;


    if (preview) {
      return (0, _ConversationFactory.getMockConversation)(initialMessage);
    }

    return currentConversation;
  },
  getConversationHistory: function getConversationHistory() {
    return this.getCurrentConversation().chatHistory;
  },
  getClassNames: function getClassNames() {
    var _props5 = this.props,
        size = _props5.size,
        preview = _props5.preview;


    return (0, _reactUtils.classNames)('widget-manager', {
      preview: preview,
      small: size === sizes.small,
      'extra-small': size === sizes['extra-small']
    });
  },
  openWidget: function openWidget() {
    var _props6 = this.props,
        clearUnseenCount = _props6.clearUnseenCount,
        onUpdateOpened = _props6.onUpdateOpened;

    this.setState({
      showInitialMessage: false
    });

    clearUnseenCount({ channel: this.getCurrentChannel() });
    onUpdateOpened(true);
  },
  closeWidget: function closeWidget() {
    var onUpdateOpened = this.props.onUpdateOpened;

    onUpdateOpened(false);
  },
  closeInitialMessage: function closeInitialMessage() {
    var onHideWelcomeMessage = this.props.onHideWelcomeMessage;

    onHideWelcomeMessage();

    this.setState({ showInitialMessage: false });
  },
  handleResendMessage: function handleResendMessage(message) {
    var _props7 = this.props,
        isOnlineMode = _props7.isOnlineMode,
        republishMessage = _props7.republishMessage;


    if (isOnlineMode) {
      republishMessage(message);
    }
  },
  fetchChatHistory: function fetchChatHistory() {
    var _props8 = this.props,
        fetchNextHistory = _props8.fetchNextHistory,
        fetchInitialHistory = _props8.fetchInitialHistory;

    var currentChannel = this.getCurrentChannel();

    if (!currentChannel || !fetchNextHistory || currentChannel === _strings.OFFLINE_MODE_CHANNEL) {
      return;
    }

    var currentConversation = this.getCurrentConversation();

    if (!(0, _ConversationModel.hasSentMessages)(currentConversation)) {
      fetchInitialHistory();
      return;
    }

    var chatHistory = currentConversation.chatHistory;
    var latestStartTime = chatHistory.startTime;

    fetchNextHistory(currentChannel, latestStartTime);
  },
  getLauncherClassName: function getLauncherClassName() {
    var _props9 = this.props,
        open = _props9.open,
        mobile = _props9.mobile;


    return (0, _reactUtils.classNames)('p-top-4 p-left-8', {
      'launcher-hidden': open && mobile
    });
  },
  setInitialMessageRef: function setInitialMessageRef(element) {
    this.initialMessageRef = (0, _reactDom.findDOMNode)(element);
  },
  setWidgetRef: function setWidgetRef(element) {
    this.widgetRef = (0, _reactDom.findDOMNode)(element);
  },
  setLauncherRef: function setLauncherRef(element) {
    this.launcherRef = (0, _reactDom.findDOMNode)(element);
  },
  getUnseenMessagesCount: function getUnseenMessagesCount() {
    var conversation = this.getCurrentConversation();
    return conversation.unseenCount;
  },
  getBadgeNumber: function getBadgeNumber() {
    var conversation = this.getCurrentConversation();
    if (!(0, _ConversationModel.hasSentMessages)(conversation)) {
      return 1;
    }
    return this.getUnseenMessagesCount();
  },
  shouldShowBadge: function shouldShowBadge() {
    var open = this.props.open;
    var showInitialMessage = this.state.showInitialMessage;
    var preview = this.props.preview;


    if (preview || open) {
      return false;
    }

    var conversation = this.getCurrentConversation();
    var unseenMessagesCount = this.getUnseenMessagesCount();

    var notSentMessagesAndNotTimedOut = !(0, _ConversationModel.hasSentMessages)(conversation) && !showInitialMessage;

    return Boolean(unseenMessagesCount) || notSentMessagesAndNotTimedOut;
  },
  shouldRenderWidget: function shouldRenderWidget() {
    var _props10 = this.props,
        chatHistoryFetchStatus = _props10.chatHistoryFetchStatus,
        preview = _props10.preview;
    var hasLoadedHistory = this.state.hasLoadedHistory;


    var currentChannel = this.getCurrentChannel();

    var hasSuccessfullyLoadedHistory = chatHistoryFetchStatus === _RequestStatusTypes2.default.SUCCEEDED || hasLoadedHistory;

    return this.props.currentConversation || hasSuccessfullyLoadedHistory || currentChannel === _strings.OFFLINE_MODE_CHANNEL || preview;
  },
  renderWidget: function renderWidget() {
    var _props11 = this.props,
        widgetData = _props11.widgetData,
        clickedMeetingsLink = _props11.clickedMeetingsLink,
        clickedForUserDescription = _props11.clickedForUserDescription,
        mobile = _props11.mobile,
        preview = _props11.preview,
        chatInputChanged = _props11.chatInputChanged,
        showTypingIndicator = _props11.showTypingIndicator,
        chatHistoryFetchStatus = _props11.chatHistoryFetchStatus,
        displayResponderOnline = _props11.displayResponderOnline,
        showEmailCapture = _props11.showEmailCapture,
        emailCaptureMessage = _props11.emailCaptureMessage,
        emailCaptureMessageIndex = _props11.emailCaptureMessageIndex,
        visiblyOffline = _props11.visiblyOffline,
        liveChatLink = _props11.liveChatLink,
        onLinkClick = _props11.onLinkClick,
        hasUnansweredQuickReplyMessage = _props11.hasUnansweredQuickReplyMessage,
        isAgentReady = _props11.isAgentReady,
        sendVisitorEmailAddress = _props11.sendVisitorEmailAddress,
        isOnlineMode = _props11.isOnlineMode;


    return _react2.default.createElement(
      'div',
      { ref: this.setWidgetRef, className: 'p-top-6', key: 'widget' },
      _react2.default.createElement(_Widget2.default, {
        isAgentReady: isAgentReady,
        chatHistoryFetchStatus: chatHistoryFetchStatus,
        widgetData: widgetData,
        currentChannel: this.getCurrentChannel(),
        currentConversation: this.getCurrentConversation(),
        publishMessage: this.props.publishMessage,
        republishMessage: this.handleResendMessage,
        sendVisitorEmailAddress: sendVisitorEmailAddress,
        clickedMeetingsLink: clickedMeetingsLink,
        clickedForUserDescription: clickedForUserDescription,
        fetchChatHistory: this.fetchChatHistory,
        mobile: mobile,
        preview: preview,
        onClose: this.closeWidget,
        chatInputChanged: chatInputChanged,
        showTypingIndicator: showTypingIndicator,
        displayResponderOnline: displayResponderOnline,
        isOnlineMode: isOnlineMode,
        showEmailCapture: showEmailCapture,
        emailCaptureMessageIndex: emailCaptureMessageIndex,
        emailCaptureMessage: emailCaptureMessage,
        visiblyOffline: visiblyOffline,
        liveChatLink: liveChatLink,
        onLinkClick: onLinkClick,
        hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage
      })
    );
  },
  renderInitialMessage: function renderInitialMessage() {
    var _props12 = this.props,
        displayResponderOnline = _props12.displayResponderOnline,
        _props12$widgetData = _props12.widgetData,
        avatar = _props12$widgetData.responder.avatar,
        initialMessage = _props12$widgetData.message.initialMessage,
        launcherType = _props12$widgetData.launcherType,
        coloring = _props12$widgetData.coloring;
    var showInitialMessage = this.state.showInitialMessage;


    if (!initialMessage || !showInitialMessage || !displayResponderOnline) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      {
        ref: this.setInitialMessageRef,
        className: 'p-top-8 p-bottom-4 p-left-5',
        key: 'initial-message-bubble'
      },
      _react2.default.createElement(_InitialMessageBubble2.default, {
        initialMessage: initialMessage,
        avatar: avatar,
        onClick: this.openWidget,
        onClose: this.closeInitialMessage,
        coloring: coloring,
        launcherType: launcherType
      })
    );
  },
  renderWidgetOrMessage: function renderWidgetOrMessage() {
    var open = this.props.open;

    return open ? this.renderWidget() : this.renderInitialMessage();
  },
  render: function render() {
    var _props13 = this.props,
        open = _props13.open,
        _props13$widgetData = _props13.widgetData,
        avatar = _props13$widgetData.responder.avatar,
        launcherType = _props13$widgetData.launcherType,
        coloring = _props13$widgetData.coloring,
        style = _props13.style;


    if (!this.shouldRenderWidget()) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: this.getClassNames(), style: style },
      _react2.default.createElement(
        'div',
        { className: 'widget-manager-content' },
        _react2.default.createElement(
          _FadeSlideTransition2.default,
          { appear: true, leave: false, direction: 'bottom' },
          this.renderWidgetOrMessage()
        )
      ),
      _react2.default.createElement(
        'span',
        { className: this.getLauncherClassName(), ref: this.setLauncherRef },
        _react2.default.createElement(
          _FadeTransition2.default,
          { appear: true, enter: false, leave: false },
          _react2.default.createElement(_Launcher2.default, {
            key: 'launcher',
            onOpen: this.openWidget,
            onClose: this.closeWidget,
            open: open,
            type: launcherType,
            avatar: avatar,
            coloring: coloring,
            showBadge: false,
            badgeNumber: this.getBadgeNumber()
          })
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/WidgetManager.js
// module id = 283
// module chunks = 0 1